import * as ACTION_TYPES from "./actionTypes";
import { unSecure } from "./API/faiz";
import { errorMessageHandle } from "../constants/utilities";
import { toast } from "react-toastify";
import { clearAccessToken, setAccessToken, setAuthenticatedEmail } from "../constants/auth";

const {
  UPDATE_LOGIN_PROPS,
  DELETE_LOGIN_PROPS,
  MERGE_LOGIN_PROPS,
  CLEAR_STATE,
} = ACTION_TYPES;
export const updateLoginProp = (prop, value) => {
  return { type: UPDATE_LOGIN_PROPS, payload: [{ prop, value }] };
};
export const updateLoginProps = (payload) => {
  return { type: UPDATE_LOGIN_PROPS, payload: payload };
};
export const mergeLoginProps = (payload) => {
  return { type: MERGE_LOGIN_PROPS, payload: payload };
};
export const deleteLoginProp = (prop) => {
  return { type: DELETE_LOGIN_PROPS, payload: [{ prop }] };
};
export const deleteLoginProps = (payload) => {
  return { type: DELETE_LOGIN_PROPS, payload };
};

export const login = (username, password, history) => (dispatch, getState) => {
  let url = "/login";
  let param = { email: username, password };
  dispatch({
    type: UPDATE_LOGIN_PROPS,
    payload: [{ prop: "isLoginLoading", value: true }],
  });
  unSecure()
    .post(url, param)
    .then((response) => {
      setAccessToken(response.data.token);
      setAuthenticatedEmail(username);
      dispatch({
        type: UPDATE_LOGIN_PROPS,
        payload: [
          { prop: "token", value: response.data.token },
          { prop: "isLoginLoading", value: false },
        ],
      });
      toast.success(response.data.msg);
      history.push("/home");
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_LOGIN_PROPS,
        payload: [{ prop: "isLoginLoading", value: false }],
      });
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    });
};

export const logout = (history) => (dispatch, getState) => {
  clearAccessToken();
  dispatch({ type: CLEAR_STATE, payload: [] });
  history.push("/login");
};
